import type {
  BaseQueryFn,
  FetchBaseQueryError,
  MutationActionCreatorResult,
  MutationDefinition,
  QueryActionCreatorResult,
  QueryDefinition,
} from "@reduxjs/toolkit/query/react"
import type { Entity, Uuid } from "@/utils"

export type BaseQueryError = FetchBaseQueryError

type Query<QueryResult> = QueryDefinition<
  unknown,
  BaseQueryFn,
  string,
  QueryResult
>

type Mutation<MutationResult> = MutationDefinition<
  unknown,
  BaseQueryFn,
  string,
  MutationResult
>

export type ActionCreatorResult<Result> =
  | QueryActionCreatorResult<Query<Result>>
  | MutationActionCreatorResult<Mutation<Result>>

export type CursorPage<TItem> = {
  items: TItem[]
  nextCursor: string | null
  prevCursor: string | null
  /** Always true on pages fetched with a forward cursor. */
  hasPrev: boolean
}

export type RealtimeHeader = {
  channel: string
  event: string
}

export type DateRange = {
  from?: Date
  to?: Date
}

// Realtime (Ably) types

export const REALTIME_HEADER = "Realtime"

export enum Operation {
  Insert = "insert",
  Update = "update",
  Delete = "delete",
}

type Insert<TEntity extends Entity> = {
  readonly operation: Operation.Insert
  readonly payload: TEntity
}

type Update<TEntity extends Entity> = {
  readonly operation: Operation.Update
  readonly payload: TEntity
}

type Remove = {
  readonly operation: Operation.Delete
  readonly payload: Entity["id"]
}

export type EntityChange<TEntity extends Entity> = { actorId: Uuid | null } & (
  Insert<TEntity> | Update<TEntity> | Remove
)
